import React, { useState } from 'react'
import IncidentsTable from './IncidentsTable'


const InvalidIncidents = () => {

  const invalidTitle = "Invalid Incidents"
  const incidentValidity = false;

  return (
    <>
      <IncidentsTable incidentTitle={invalidTitle}  incidentValidity={ incidentValidity}/>
    </>
  )
}

export default InvalidIncidents